import "@ant-design/v5-patch-for-react-19";
import {ConfigProvider, App as AntdApp} from "antd";
import * as Sentry from "@sentry/react";
import "./index.css";
import {ToastProvider} from "./components/ToastContext";
import AppRoutesNew from "./routes/AppRoutesNew";
import ErrorBoundary from "./components/Common/ErrorBoundary";

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#128C7E",
        },
      }}
    >
      <AntdApp>
        <ToastProvider>
          <ErrorBoundary
            onError={(error, errorInfo) => {
              Sentry.captureException(error, {extra: {errorInfo}});
            }}
          >
            <AppRoutesNew />
          </ErrorBoundary>
        </ToastProvider>
      </AntdApp>
    </ConfigProvider>
  );
}

export default App;
